var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSofa1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49999 7.5C4.46587 7.5 4.43186 7.50043 4.39795 7.50128C5.44736 4.30668 8.45429 2 12 2C15.5457 2 18.5526 4.30668 19.602 7.50128C19.5681 7.50043 19.5341 7.5 19.5 7.5C17.2909 7.5 15.4999 9.29079 15.4999 11.5V13.5H8.4999V11.5248L8.49999 11.5064V11.5C8.49999 9.29086 6.70913 7.5 4.49999 7.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99991 11.5216L7 11.5C7 10.1193 5.88071 9 4.5 9C3.11929 9 2 10.1193 2 11.5C2 12.7592 2.93098 13.801 4.14218 13.9746V16C4.14218 17.3462 5.02883 18.4852 6.25 18.8651V21C6.25 21.4142 6.58579 21.75 7 21.75C7.41421 21.75 7.75 21.4142 7.75 21V19H16.25V21C16.25 21.4142 16.5858 21.75 17 21.75C17.4142 21.75 17.75 21.4142 17.75 21V18.865C18.9711 18.4851 19.8576 17.3461 19.8576 16V13.9746C21.0689 13.8011 22 12.7593 22 11.5C22 10.1193 20.8807 9 19.5 9C18.1193 9 16.9999 10.1193 16.9999 11.5V14C16.9999 14.5523 16.5522 15 15.9999 15H7.99991C7.44762 15 6.99991 14.5523 6.99991 14V11.5216Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofa1);
export default __webpack_public_path__ + "static/media/sofa-1.7487ff7fc911a7c131d462ecaf12ed64.svg";
export { ForwardRef as ReactComponent };